import Product from '@common/models/Product';
// import Rupee from '@instamojo/rupee';
// import Button from '@lib/Button';
import classnames from 'classnames';
import React from 'react';

// import Savings from '../Tags/Savings';

interface SelectVariantsProps {
  product: Product;
  selectedOptions: Array<number>;
  setSelectedOptions: (selectedOptions: Array<number>) => void;
  quantity: number;
  setQuantity: (quantity: number) => void;
}

const SelectVariants: React.FC<SelectVariantsProps> = ({ product, selectedOptions, setSelectedOptions }) => {
  return (
    <>
      {product.optionNames.map((optionName, index) => (
        <div key={optionName} className="mt-20 mb-8">
          <div className="flex items-center mb-8">
            <div
              className="text-theme font-medium text-14 md:text-16 mr-4"
              font-customisation="para-text"
              color-customisation="page-body-text"
              id={'variant-type-' + (parseInt(index) + 1)}
            >
              {optionName}
            </div>
            {/* <div className="text-16 font-medium">{product.allOptionValues[index][selectedOptions[index]]}</div> */}
          </div>
          {OtheroptionsBar(product, index, selectedOptions, setSelectedOptions)}
        </div>
      ))}
    </>
  );
};

//ColoroptionsBar
// const ColoroptionsBar = (designType, product, index, selectedOptions, setSelectedOptions) => {
//   return (
//     <div className="flex flex-wrap">
//       {product.allOptionValues[index].map((optionValue, optionIndex) => (
//         <div
//           key={optionValue}
//           className={classnames('cursor-pointer rounded-full mb-12 mr-2 p-2', {
//             'border-solid border-2 border-black': optionIndex === selectedOptions[index],
//             'border-none': optionIndex !== selectedOptions[index],
//           })}
//           onClick={() => {
//             console.log(selectedOptions[index], optionIndex);
//             const newSelectedOptions = [...selectedOptions];
//             newSelectedOptions[index] = optionIndex;
//             setSelectedOptions(newSelectedOptions);
//           }}
//         >
//           <div
//             className={classnames('cursor-pointer w-12 h-12 rounded-full')}
//           ></div>
//         </div>
//       ))}
//     </div>
//   );
// };

//OtheroptionsBar
const OtheroptionsBar = (product, index, selectedOptions, setSelectedOptions) => {
  return (
    <div className="flex flex-wrap">
      {product?.allOptionValues[index]?.map((optionValue, optionIndex) => (
        <div
          key={optionValue}
          className={classnames(
            'cursor-pointer text-14 font-bold mb-12 rounded-full px-20 py-6 mr-10 last:mr-0 tracking-wide',
            {
              'text-white font-bold bg-variant-selectedBg': optionIndex === selectedOptions[index],
              'text-theme font-bold bg-variant-bg': optionIndex !== selectedOptions[index],
            },
          )}
          font-customisation="para-text"
          onClick={() => {
            const newSelectedOptions = [...selectedOptions];
            newSelectedOptions[index] = optionIndex;
            setSelectedOptions(newSelectedOptions);
          }}
          color-customisation="page-body-text"
          id={'type' + (parseInt(index) + 1) + '-v' + (parseInt(optionIndex) + 1)}
        >
          {optionValue}
        </div>
      ))}
    </div>
  );
};
export default SelectVariants;
